import moment from 'moment';
import { LitEntity, renderIf, html } from '../../utility/lit-entity';
import { ActiveWorkOrderWatcherMixin } from '../../utility/active-work-order-watcher-mixin';
import '../../common/bn-banner';

class BinWorkOrderBanner extends ActiveWorkOrderWatcherMixin(LitEntity) {
  render() {
    const banners = Object.values(this.activeWorkOrderMap).map((activeWorkOrder) => {
      const { scheduledFor, preDiagnosis, requestType, isDataReliable, isColdWeatherIssue } = activeWorkOrder.properties;

      const isService = requestType === 'service';

      if (isService && isDataReliable && !isColdWeatherIssue) {
        return html``;
      }

      const bin = activeWorkOrder.getSubEntityByClass('bin');

      if (isService && isColdWeatherIssue) {
        const title = html`
          <bin-name .href="${bin.href}"></bin-name> is Offline due to cold weather.
        `;
        return html`
          <bn-banner severity="cold" .title="${title}">
            <div>As temperatures return to seasonal levels the bin will come back online.</div>
          </bn-banner>
        `;
      }

      const title = html`
        <bin-name .href="${bin.href}"></bin-name>
        scheduled for ${requestType}
        ${scheduledFor ? ` on ${this._formatDate(scheduledFor)}` : ''}
      `;

      return html`
        <bn-banner severity="info" .title="${title}">
          ${renderIf(isService && !isDataReliable, () => html`
            <div>Data may not be reliable</div>
          `)}
          ${renderIf(isService && preDiagnosis, () => html`
            <div class="subdued">Pre Diagnosis: ${preDiagnosis}</div>
          `)}
        </bn-banner>
      `;
    });

    return html`${banners}`;
  }

  _formatDate(date) {
    return moment(date).format('MMMM Do');
  }
}

window.customElements.define('bin-work-order-banner', BinWorkOrderBanner);
